import { IconAdd, Text, TextLinkButton } from 'braid-design-system';
import React, { type MouseEvent } from 'react';

interface Props {
  label: string;
  handleAddItem?: (event: MouseEvent<HTMLElement>) => void;
}

export const AddItemButton = ({ handleAddItem, label }: Props) => (
  <Text>
    <TextLinkButton onClick={handleAddItem}>
      <IconAdd />
      {label}
    </TextLinkButton>
  </Text>
);
